import React from "react";
import { footerUrls } from "../../../constants";
import Analytics from "../../../analytics";
import Event from "../../../analytics/eventFactory";

function mediaClick(e, socialMedia) {
  e.preventDefault();
  Analytics.trackEvent({
    action: socialMedia,
    category: Event.category.FOOTER,
  });

  window.location = e.target.parentElement.href;
}
function SocialMediaLinks() {
  return (
    <div className="nw-social-media-container">
      <a
        className="nw-social-media-links"
        href={footerUrls.facebook}
        onClick={e => mediaClick(e, Event.action.FB_CLICK)}
      >
        <i className="icomoon-facebook" />
      </a>
      <a
        className="nw-social-media-links"
        href={footerUrls.intagram}
        onClick={e => mediaClick(e, Event.action.INSTA_CLICK)}
      >
        <i className="icomoon-instagram" />
      </a>
    </div>
  );
}

export default SocialMediaLinks;



// WEBPACK FOOTER //
// ./src/component/Footer/SocialMediaLinks/index.js